import { LauncherApp } from "./types";

interface AppLauncherTileProps {
  app: LauncherApp;
  /** Called after the tile is activated so the panel can close. */
  onSelect: () => void;
}

const AppLauncherTile = ({ app, onSelect }: AppLauncherTileProps) => (
  <a
    className="app-launcher-tile"
    href={app.url}
    target="_blank"
    rel="noopener noreferrer"
    onClick={onSelect}
  >
    <span className="app-launcher-tile-icon">
      {/* Decorative: the visible label conveys the name. */}
      <img src={app.iconUrl} alt="" aria-hidden="true" />
    </span>
    <span className="app-launcher-tile-label">{app.name}</span>
  </a>
);

export default AppLauncherTile;
